require('./impositionDetailBox.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');
// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const {
    IMPOSITION_STATUS_CANCELED,
    IMPOSITION_STATUS_EXPIRED,
    IMPOSITION_STATUS_VALID
} = require('utilities/contactCenter/impositionsHelper');
// @ helpers
const { formatPercentage, formatInterest } = require('utilities/currencyHelper');
// @ commons
const { LabelDate } = require('commonsComponents/labelDate');
const OKTag = require('components/commons/OKTag/OKTag');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents')
const { COUNTRIES_CODES: { NL, PT, DE, ES } } = require('constants/countries');
class ImpositionDetailBox extends React.Component {

    buildEarlyCancelButtons(depositId, impositionId) {
        return (<div className="imposition-detail__section imposition-detail__section--cancel-buttons">
            <div className="imposition-detail__early-cancel-button">
                <OKButton
                    modifier="primary"
                    to={`/myprofile/deposits/${depositId}/imposition/${impositionId}/early-cancel`}
                >
                    <FormattedText value="imposition-cancel"/>
                </OKButton>
            </div>
            <div className="imposition-detail__early-cancel-button">
                <OKButton
                    modifier="ghost"
                    to={`/myprofile/deposits/${depositId}/imposition/${impositionId}/simulate-early-cancellation`}
                >
                    <FormattedText value="imposition-simulateEarlyCancellation"/>
                </OKButton>
            </div>
        </div>);
    }

    render() {
        const language = getLanguage();
        const {
            depositId,
            impositionId,
            firstPeriod,
            lastRenewal,
            expireDate,
            tae,
            tin,
            impositionStatus,
            originCountry,
            status,
            isClosed
        } = this.props;
        const lastRenewalLabel = firstPeriod ? 'imposition-hiringDate' : 'imposition-lastRenewal';
        const taeString = formatInterest(tae);
        const tinString = [ES].includes(originCountry) ? formatPercentage(tin) : formatInterest(tin);


        let statusTag, interesRenewalSection;
        if (status) {
            statusTag = (
                <div className="imposition-detail__tag">
                    <OKTag content={status} context="arrow" />
                </div>
            );
        }

        if (!isClosed) {
            if ([NL, PT, ES, DE].includes(originCountry)){
                interesRenewalSection = (
                    <div className="imposition-detail__section imposition-detail__section--single-item">
                        <OKInformativeList columns={1}>
                            <OKInformativeListItem
                                className="imposition-detail__list-item"
                                title="imposition-tin"
                                bodyText={tinString}
                            />
                        </OKInformativeList>
                    </div>
                );
            } else {
                interesRenewalSection = (
                    <div className="imposition-detail__section imposition-detail__section--single-item">
                        <OKInformativeList columns={1}>
                            <OKInformativeListItem
                                className="imposition-detail__list-item"
                                title="imposition-tae"
                                bodyText={taeString}
                            />
                        </OKInformativeList>
                    </div>
                );
            }
        }

        const impositionDetailClass = classnames('imposition-detail__section', {
            'imposition-detail__section-centered': isClosed
        });

        const isCancellable = impositionStatus === IMPOSITION_STATUS_VALID;
        let earlyCancelButtons;
        if (__CONTACT_CENTER__ && isCancellable) {
            earlyCancelButtons = this.buildEarlyCancelButtons(depositId, impositionId);
            statusTag = null;
        }

        const sectionBox = classnames('imposition-detail', {
            cancellable: __CONTACT_CENTER__ && isCancellable
        });

        const sectionBoxClassName = contactCenterClassName(sectionBox)

        return (
            <OKSectionBox className={sectionBoxClassName}>
                <div className={impositionDetailClass}>
                    <div className="imposition-detail__date-element">
                        <p className="imposition-detail__date-label"><FormattedText value={lastRenewalLabel} /></p>
                        <p className="imposition-detail__date">
                            <LabelDate
                                date={lastRenewal}
                                language={language}
                                today={LABEL_DATE_TODAY}
                                yesterday={LABEL_DATE_YESTERDAY}
                            />
                        </p>
                    </div>
                    <i className="icon arrow-separator imposition-detail__icon" />
                    <div className="imposition-detail__date-element imposition-detail__date-element--bigger-margin">
                        <p className="imposition-detail__date-label"><FormattedText value="imposition-expireDate" /></p>
                        <p className="imposition-detail__date">
                            <LabelDate
                                date={expireDate}
                                language={language}
                                today={LABEL_DATE_TODAY}
                                yesterday={LABEL_DATE_YESTERDAY}
                            />
                        </p>
                    </div>
                </div>
                {interesRenewalSection}
                <ContactCenterRender>
                    {earlyCancelButtons}
                </ContactCenterRender>
                {statusTag}
            </OKSectionBox>
        );
    }
}

ImpositionDetailBox.propTypes = {
    depositId: PropTypes.string,
    impositionId: PropTypes.string,
    firstPeriod: PropTypes.bool.isRequired,
    lastRenewal: PropTypes.string.isRequired,
    expireDate: PropTypes.string.isRequired,
    originCountry: PropTypes.string.isRequired,
    tae: PropTypes.number.isRequired,
    tin: PropTypes.number,
    impositionStatus: PropTypes.oneOf([
        IMPOSITION_STATUS_CANCELED,
        IMPOSITION_STATUS_EXPIRED,
        IMPOSITION_STATUS_VALID,
    ]),
    status: PropTypes.oneOf([
        'imposition-canceledStatus',
        'imposition-expiredStatus',
        'impositionRow-canceled',
        'impositionRow-expired',
        'impositionRow-valid'
    ]),
    isClosed: PropTypes.bool
};

module.exports = ImpositionDetailBox;
